import React, { Component } from "react";
import { PropTypes } from "prop-types";
import GripIcon from "@zendeskgarden/svg-icons/src/12/grip.svg";
import { Spinner } from "@zendeskgarden/react-loaders";
import classnames from "classnames";
import { Menu, Item } from "@zendeskgarden/react-menus";
import EllipsisIcon from "@zendeskgarden/svg-icons/src/26/ellipsis.svg";
import t from "@zendesk/client-i18n-tools";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import MoveToModal from "../MoveToModal";
import styles from "./index.css";

const KEY_ENTER = 13;

export default class SectionRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMoveToModalVisible: false,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
    this.onMoveToClick = this.onMoveToClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onMoveToTop = this.onMoveToTop.bind(this);
  }

  onKeyDown(e) {
    const { onClick } = this.props;

    if (e.keyCode === KEY_ENTER) {
      onClick();
    }
  }

  onEditClick(e) {
    e.stopPropagation();
    const { section } = this.props;
    window.open(
      `/knowledge/sections/${section.id}?brand_id=${getCurrentBrandId()}`,
      "_blank"
    );
  }

  onViewClick(e) {
    e.stopPropagation();
    const { section } = this.props;
    window.open(section.html_url, "_blank");
  }

  onMoveToClick(e) {
    e.stopPropagation();
    this.setState({ isMoveToModalVisible: true });
  }

  onModalClose() {
    this.setState({ isMoveToModalVisible: false });
  }

  onMoveToTop(e) {
    e.stopPropagation();

    const { onMoveToTop } = this.props;
    onMoveToTop();
  }

  render() {
    const {
      section,
      testId,
      onClick,
      highlight,
      dragHandleProps,
      saving,
      success,
      onMoveTo,
    } = this.props;

    const { isMoveToModalVisible } = this.state;

    const menu = (
      <Menu
        data-test-id={testId && `${testId}-menu`}
        trigger={({ ref, isOpen }) => (
          <span
            ref={ref}
            role="button"
            tabIndex={0}
            aria-label={t("knowledge-arrange.section.menuAriaLabel")}
            className={classnames(styles.trigger, {
              [styles.open]: isOpen,
            })}
            data-test-id={testId && `${testId}-menu-trigger`}
            onClick={e => e.stopPropagation()}
          >
            <EllipsisIcon />
          </span>
        )}
      >
        <Item
          data-test-id={testId && `${testId}-edit`}
          onClick={this.onEditClick}
        >
          {t("knowledge-arrange.section.edit")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-move-to`}
          onClick={this.onMoveToClick}
        >
          {t("knowledge-arrange.moveTo.menuItem")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-move-to-top`}
          onClick={this.onMoveToTop}
        >
          {t("knowledge-arrange.section.sendToTop")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-view`}
          onClick={this.onViewClick}
        >
          {t("knowledge-arrange.section.view")}
        </Item>
      </Menu>
    );

    return (
      <div>
        {isMoveToModalVisible && (
          <MoveToModal
            onMove={onMoveTo}
            onClose={this.onModalClose}
            name={section.name}
            destinationTypes={["Section", "Category"]}
          />
        )}
        <div
          tabIndex={0}
          className={classnames(styles.row, {
            [styles.saving]: saving,
            [styles.success]: success,
            [styles.highlight]: highlight,
          })}
          onClick={onClick}
          onKeyDown={this.onKeyDown}
          data-test-id={testId && `${testId}-row`}
        >
          <div
            role="button"
            tabIndex={0}
            className={styles.grip}
            data-test-id={testId && `${testId}-drag-handle`}
            {...dragHandleProps}
          >
            <GripIcon />
          </div>
          <div className={styles.content}>
            <div
              className={styles.name}
              data-test-id={testId && `${testId}-name`}
            >
              {section.name}
            </div>
            <div
              className={styles.additional}
              data-test-id={testId && `${testId}-detail`}
            >
              {t("knowledge-arrange.sectionCount", {
                count: section.section_count,
              })}{" "}
              ·{" "}
              {t("knowledge-arrange.articleCount", {
                count: section.article_count,
              })}
            </div>
          </div>

          {saving ? (
            <div className={styles.loader}>
              <Spinner delayMs={0} />
            </div>
          ) : (
            menu
          )}
        </div>
      </div>
    );
  }
}

SectionRow.defaultProps = {
  highlight: false,
  saving: false,
  success: false,
};

SectionRow.propTypes = {
  section: PropTypes.shape({
    name: PropTypes.string.isRequired,
    edit_url: PropTypes.string.isRequired,
    html_url: PropTypes.string.isRequired,
    section_count: PropTypes.number.isRequired,
    article_count: PropTypes.number.isRequired,
  }).isRequired,
  testId: PropTypes.string,
  onClick: PropTypes.func,
  highlight: PropTypes.bool,
  dragHandleProps: PropTypes.object,
  saving: PropTypes.bool,
  success: PropTypes.bool,
  onMoveTo: PropTypes.func.isRequired,
  onMoveToTop: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/SectionRow/index.js